var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('label',{staticClass:"bool-switch",attrs:{"for":_vm.idcss}},[_c('input',{attrs:{"id":_vm.idcss,"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"input":_vm.change}}),_c('span',{staticClass:"bool-switch_slider"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }